import { denormalizeWalls } from '~/components/DrawingCanvas/lib/collisionMeshes'
import { getInteriorWallFullHeight } from '~/components/DrawingCanvas/Walls/util'
import { createAppSelector } from '~/store/hooks'

export const selectExteriorWallMinHeight = createAppSelector(
  [state => state.objects.present.segments],
  getInteriorWallFullHeight
)

export const selectDenormalizedWalls = createAppSelector(
  [state => state.objects.present.segments, state => state.objects.present.objects],
  denormalizeWalls
)
